export default __webpack_public_path__ + "static/media/trinity_force.470d0932.png";